__turbopack_context__.v({
  "ReviewCard": "CustomerReview-module-scss-module__TwyM6a__ReviewCard",
  "blank": "CustomerReview-module-scss-module__TwyM6a__blank",
  "customerReview": "CustomerReview-module-scss-module__TwyM6a__customerReview",
  "highlightText": "CustomerReview-module-scss-module__TwyM6a__highlightText",
  "reviewGradientLeft": "CustomerReview-module-scss-module__TwyM6a__reviewGradientLeft",
  "reviewGradientRight": "CustomerReview-module-scss-module__TwyM6a__reviewGradientRight",
  "reviewLists": "CustomerReview-module-scss-module__TwyM6a__reviewLists",
  "reviewSwiper": "CustomerReview-module-scss-module__TwyM6a__reviewSwiper",
  "titleContent": "CustomerReview-module-scss-module__TwyM6a__titleContent",
  "wrap": "CustomerReview-module-scss-module__TwyM6a__wrap",
});
